<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">Интересное</h2>
      </div>
      <div class="d-flex">
        <div class="justify-content-center">
          <router-link to="/interesting/add" type="button" class="btn btn-primary my-2 btn-icon-text">
            <i class="fe fe-plus-square mr-2"></i> Добавить статью
          </router-link>
        </div>
      </div>
    </div>
    <div class="row row-sm">
      <div class="col-lg-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Список статей</h6>
            </div>
            <div class="table-responsive">
              <b-table striped hover :items="interestingArticles" :fields="tableFields">
                <template #cell(image)="row">
                  <img v-if="row.item.image" class="img-thumbnail table-image" :src="row.item.image" alt="avatar">
                  <div v-else>No image</div>
                </template>
                <template #cell(category_interesting)="row">
                  <p class="badge text-white bg-info mr-1" >{{row.item.category_interesting.title[$i18n.locale]}}</p>
                </template>
                <template #cell(status)="row">
                  <span class="badge text-white" :class="{'bg-success': row.item.status === 'active', 'bg-danger': row.item.status !== 'active'}">{{row.item.status}}</span>
                </template>
                <template #cell(actions)="row">
                  <router-link :to="`/interesting/${row.item.id}`" class="btn btn-outline-primary mr-2 mt-1 mb-1">
                    <i class="fe fe-edit"></i>
                  </router-link>
                  <button v-if="row.item.status === 'active'" @click="removeInteresting(row.item.id)" type="button" class="btn btn-outline-danger mr-2 mt-1 mb-1">
                    <i class="ti-close"></i>
                  </button>
                  <div v-else class="d-inline-block">
                    <button @click="restoreInteresting(row.item.id)" type="button" class="btn btn-outline-success mr-2 mt-1 mb-1">
                      <i class="fe fe-rotate-ccw"></i>
                    </button>
                    <button @click="removeInteresting(row.item.id)" type="button" class="btn btn-outline-danger mr-2 mt-1 mb-1">
                      <i class="fe fe-trash-2"></i>
                    </button>
                  </div>
                </template>
              </b-table>
              <div class="d-flex justify-content-end  mt-3">
                <div class="mr-3">
                  <b-form-select
                    @change="changePaginationPerPage"
                    style="width: 80px"
                    v-model="paginationPerPage"
                    :options="paginationOptions"
                  >
                  </b-form-select>
                </div>
                <div>
                  <b-pagination
                    class="m-0"
                    @change="changePagination"
                    v-model="paginationCurrentPage"
                    :total-rows="pagination.count"
                    :per-page="paginationPerPage"
                    first-text="<<"
                    prev-text="<"
                    next-text=">"
                    last-text=">>"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Swal from 'sweetalert2'

export default {
  name: 'Interesting',
  data () {
    return {
      paginationOptions: [
        { value: 6, text: '6' },
        { value: 10, text: '10' },
        { value: 30, text: '30' },
        { value: 100, text: '100' }
      ],
      paginationCurrentPage: 1,
      paginationPerPage: 6,
      pagination: {}
    }
  },
  computed: {
    ...mapState({
      interestingArticles: state => state.interesting.interestingArticles,
      faqList: state => state.faq.faqList
    }),
    tableFields () {
      return [
        {
          key: 'id',
          sortable: true
        },
        {
          key: 'image',
          label: 'Фото',
          sortable: true
        },
        {
          key: 'title.' + this.$i18n.locale,
          label: 'Название',
          sortable: true
        },
        {
          key: 'short_description.' + this.$i18n.locale,
          label: 'Короткое описание',
          sortable: true
        },
        {
          key: 'category_interesting',
          label: 'Категория',
          sortable: true
        },
        {
          key: 'status',
          label: 'Статус',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Действие',
          sortable: false
        }
      ]
    }
  },
  created () {
    this.getAllInterestingArticlesList({})
  },
  methods: {
    ...mapActions({
      getAllInterestingArticles: 'interesting/getAllInterestingArticles',
      getAllFaqs: 'faq/getAllFaqs',
      restoreInterestingArticle: 'interesting/restoreInterestingArticle',
      deleteInterestingArticle: 'interesting/deleteInterestingArticle'
    }),
    changePaginationPerPage (value) {
      this.getAllInterestingArticlesList({ page: this.paginationCurrentPage, count: value })
    },
    changePagination (page) {
      this.getAllInterestingArticlesList({ page: page, count: this.paginationPerPage })
    },
    getAllInterestingArticlesList (params) {
      this.getAllInterestingArticles(params).then(res => {
        this.pagination = res.pagination
      }).catch(() => {
        this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
      })
    },
    removeInteresting (id) {
      Swal.fire({
        text: this.$t('messages.warning.delete'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#748C41',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then((result) => {
        if (result.value) {
          this.deleteInterestingArticle(id).then(res => {
          }).catch(() => {
            this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
          })
        }
      })
    },
    restoreInteresting (id) {
      Swal.fire({
        text: this.$t('message.warning.restore'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#748C41',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then((result) => {
        if (result.value) {
          this.restoreInterestingArticle(id).then(res => {
            this.$toasted.success(this.$t('messages.success.faqRestored')).goAway(1500)
          }).catch(() => {
            this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
          })
        }
      })
    }
  }
}
</script>
